import ReactApexChart from 'react-apexcharts';
import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

import ChartError from 'src/modules/3rd-party-management/pages/admin/compliance/components/dashboard/ChartError';

import useTradeOperations from './hooks/useTradeOperations';

const TradeOperationsSkeleton = () => (
    <Card className="h-100 mb-0">
        <CardBody>
            <div className="dt-field dt-skeleton mb-2" style={{ width: '20%' }} />
            <div className="dt-field dt-skeleton" style={{ width: '100%', height: '320px' }} />
        </CardBody>
    </Card>
);

const TradeOperations = ({
    t,
}) => {
    const {
        categories,
        chartSeries,
        isFetching,
        isError,
        error,
        refetch,
    } = useTradeOperations({ t });

    if (isFetching) {
        return <TradeOperationsSkeleton />;
    }

    const options = {
        chart: {
            height: 320,
            toolbar: {
                show: false,
            },
            type: 'line',
            zoom: {
                enabled: false,
            },
        },
        legend: {
            show: true,
            position: 'bottom',
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: 'straight',
        },
        grid: {
            row: {
                colors: ['#f3f3f3', 'transparent'],
                opacity: 0.5,
            },
        },
        xaxis: {
            categories,
        },
        yaxis: {
            min: 0,
            forceNiceScale: true,
            decimalsInFloat: 0,
            labels: {
                formatter: (value) => Math.round(value),
            },
        },
    };

    return (
        <Card className="h-100 mb-0">
            <CardBody>
                <div className="mb-4">
                    <CardTitle tag="h6">
                        {t('EUDR Trade Operations')}
                    </CardTitle>
                </div>

                <div className="mb-3">
                    {isError ? (
                        <ChartError
                            title={
                                error?.response?.status === 403
                                    ? 'Error 403'
                                    : null
                            }
                            message={
                                error?.response?.status === 403
                                    ? 'Please upgrade your plan to access this feature'
                                    : null
                            }
                            onRetry={refetch}
                        />
                    ) : (
                        <ReactApexChart
                            options={options}
                            series={chartSeries}
                            type="line"
                            height="280"
                        />
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(TradeOperations);
